import React from "react";
import { useLocation } from "react-router-dom";
import DefaultImage from "../../assets/img/default-image.jpg";
import AdsCard from "../../components/common/AdsCard/AdsCard";
// import MainButton from "../../components/common/MainButton/MainButton";
import useAuth from "../../Hooks/useAuth";

const ServiceCards = ({ addType, Services }) => {
  function useParams() {
    return new URLSearchParams(useLocation().search);
  }
  const params = useParams();
  const CategoryId = params.get("id");
  const { auth } = useAuth();

  return (
    <>
      {Services?.map((e, index) => {
        // const ListImage = JSON.parse(e?.pictures);
        return (
          <AdsCard
            key={index}
            isFeatured={true}
            serviceName={e?.postTitle}
            serviceDescription={e?.postDescription}
            category={e?.mainCategory}
            // type={e?.listType}
            Images={e?.content ? JSON.parse(e.content) : []}
            // rating={e?.listRating}
            companyName={e?.user.businessName}
            companyLogo={e?.user.profilePicture}
            serviceId={e?.id}
            companyId={e?.user.id}
            // reaction={e?.listReaction}
            likes={e?.likes || 0}
            views={e?.views || 0}
            userPlan={e?.user?.userPlan?.plan?.name?.toLowerCase()}
          />
        );
      })}

      {/* {Services?.length > 15 && (
          <div className="flex justify-center items-center">
            <MainButton
              variant={"filled"}
              className="min-h-[50px] min-w-[300px] text-4xl"
            >
              Load More
            </MainButton>
          </div>
        )} */}
    </>
  );
};

export default ServiceCards;
